import { motion } from "framer-motion";
import { FaLine } from "react-icons/fa6";
import { fadeInUp } from "@/components/motionVariants";

export const ScarcitySection = ({ lineUrl }) => {
  return (
    <motion.section
      className="py-16 md:py-24"
      data-testid="scarcity-section"
      {...fadeInUp}
    >
      <div className="mx-auto max-w-md px-6 md:max-w-4xl md:px-12 lg:max-w-6xl">
        <div
          className="rounded-3xl border border-gold/20 bg-white px-6 py-12 text-center shadow-soft"
          data-testid="scarcity-card"
        >
          <p className="font-serif text-2xl text-taupe md:text-3xl" data-testid="scarcity-title">
            รับเพียงจำนวนจำกัดต่อวัน
          </p>
          <p className="mt-3 text-base text-taupeLight" data-testid="scarcity-description">
            เพื่อให้คุณได้รับการดูแลอย่างเต็มที่ และมีเวลาในบทสนทนาที่สงบที่สุด
          </p>
          <a
            href={lineUrl}
            target="_blank"
            rel="noreferrer"
            className="mt-8 inline-flex items-center gap-3 rounded-full bg-line px-7 py-3 text-sm font-semibold text-white shadow-glow-line transition-shadow duration-300 hover:shadow-[0_0_30px_rgba(0,195,0,0.7)]"
            data-testid="scarcity-cta"
            aria-label="จองผ่าน LINE ตอนนี้"
          >
            <FaLine className="text-lg" data-testid="scarcity-cta-icon" />
            <span data-testid="scarcity-cta-text">จองผ่าน LINE ตอนนี้</span>
          </a>
        </div>
      </div>
    </motion.section>
  );
};